import type { LocationId } from '../types';

const normalizeLocationId = (
  id: LocationId | number | null | undefined
): string => String(id ?? '');

export default normalizeLocationId;
